<template>
    <div class="dropdown" :class="{ 'dropdown--open': open, 'dropdown--no-shadow': noShadow, 'dropdown--clickable': !open && !disabled }" v-on:click="stageClicked">

        <icon :icon="icon" v-if="!backBtn"></icon>

        <div class="dropdown__back-btn" v-if="backBtn" v-on:click="goBack">
          &lt; {{$t('global.back')}}
        </div>

        <div class="dropdown__title">
            {{ placeholder }}
        </div>
        <div class="dropdown__edit-btn" v-if="!open && !disabled">
          {{$t('global.edit')}}
        </div>
    </div>
</template>

<script>
    import icon from './icon'

    export default {
      name: 'dropDown',
      props: [
        'icon',
        'placeholder',
        'open',
        'noShadow',
        'stageIndex',
        'disabled',
        'backBtn',
        'contentRef'
      ],
      components: {
        'icon': icon
      },
      data () {
        return {
          stage: 1
        }
      },
      methods: {
        stageClicked () {
          if (this.backBtn) return
          if (this.disabled) return
          if (this.$parent.stageManager.stageIsOpen(this.stageIndex)) {
            this.$emit('bounceContent', this.contentRef)
            return
          }

          this.$emit('click')
        },
        openStage (stageIndex) {
          if (this.backBtn) return
          if (this.disabled) return
          const stageManager = this.$parent.stageManager
          stageManager.openStage(stageIndex)
        },
        goBack () {
          const stageManager = this.$parent.stageManager
          const availabilityService = this.$parent.availabilityService
          const previous = stageManager.getBackButtonContext()
          stageManager.openStage(previous)
          availabilityService.closePrompt()
        }
      }
    }
</script>



// WEBPACK FOOTER //
// dropDown.vue?07322248